import { Component } from '@angular/core';
import { PageTrackerService } from './services/page-tracker.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'web-app';
  constructor(private trackingService: PageTrackerService) {
    this.trackingService.startTracking();
  }
}
